import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import layout from "antd/lib/layout"
import { useDispatch, useSelector } from "react-redux"
import axios from "axios"

export const PreviewImgOrPdf = (props: {
  token: string
  AXIOS_IP: string
  file: any
  onClose: () => void
}) => {
  const [baseUrl, setBaseUrl] = useState("")

  const [isModalVisible, setIsModalVisible] = useState(false) //预览

  const [baseType, setBaseType] = useState(true)

  const getBase64Url = (v: any, type = false) => {
    axios({
      url: `${props.AXIOS_IP}/infra/file/downloadFile/${v.fileConfigId}/${v.filePath}`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "GET",
    }).then((res: any) => {
      if (type) {
        const link = document.createElement("a")
        link.href = `data:${v.fileType};base64,${res.data}`
        link.download = "参考模板.pdf"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else {
        setBaseType(v.fileType?.includes("pdf") ? true : false)
        setBaseUrl(`data:${v.fileType};base64,${res.data}`)
        setIsModalVisible(true)
      }
    })
  }

  useEffect(() => {
    if (props.file) {
      getBase64Url(props.file)
    }
  }, [props.file])

  return (
    <>
      <Modal
        title={"预览"}
        visible={isModalVisible}
        footer={null}
        width={"80%"}
        onCancel={() => {
          setIsModalVisible(false)
          props.onClose()
        }}
      >
        <div style={{ height: "650px" }}>
          {baseType ? (
            <iframe
              title="预览"
              style={{ width: "100%", height: "100%" }}
              src={baseUrl}
            />
          ) : (
            <img
              v-else
              src={baseUrl}
              alt="预览图片"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          )}
        </div>
      </Modal>
    </>
  )
}
